import * as Types from './types'

export const modalStateValid = (state: Types.ModalData): boolean =>
  state.tags !== ''

export const modalAddStateValid = (state: Types.ModalData): boolean =>
  state.tags !== '' && state.name !== ''



// WEBPACK FOOTER //
// ./src/pages/filter-group/utils.ts